import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import CategoryCard from '@/components/base/CategoryCard';

export default function CategorySection() {
  return (
    <section className="bg-background-100/50 py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            资源分类导航
          </h2>
          <p className="text-foreground-600 mt-2 text-sm">八大分类，精准定位你需要的免费资源</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <CategoryCard key={cat.slug} category={cat} />
          ))}
        </div>
        <div className="text-center mt-8">
          <Link
            to="/category/ai-tools"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            浏览全部分类 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}